import styled from 'styled-components';

export const MainImageStyles = styled.section<{
  backgroundSrc: string;
  extraHeight?: number;
}>`
  body.dark & {
  }

  margin: 0;
  padding: 20px 0;
  position: relative;
  background: url(${(props) => props.backgroundSrc});
  background-repeat: no-repeat;
  background-position: top center;
  background-size: 500px auto;
  max-width: 500px;
  margin: 0 auto;
  min-height: ${(props) => 980 + (props.extraHeight || 0)}px;
`;

export const MainImageContentStyles = styled.div`
  z-index: 1;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, -10px);
  width: 100%;

  .main-image-title {
    margin: 0 0 8px;
    font-size: 24px;
    line-height: 40px;
  }
`;

export const TitleHighlightAlt = styled.span`
  border-radius: 7px;
  background: linear-gradient(90deg, #803eff 0%, #ff3636 100%);
  padding: 4px 2px;
`;
